module.exports = __webpack_public_path__ + "static/media/logo_gorila.226ff5db.svg";